import type { CreditsResponse } from '@shared/api';

/**
 * The one line the start screen shows about proposal credits
 * (docs/limits.md), or null when the rep has no limit at all.
 */
export function creditsLine(credits: CreditsResponse | null): { text: string; blocked: boolean } | null {
  if (!credits || credits.unlimited || credits.remaining === null) return null;
  if (credits.blockedMessage) return { text: credits.blockedMessage, blocked: true };
  const remaining = credits.remaining;
  const tightest = credits.limits.find((limit) => limit.remaining === remaining);
  const period =
    tightest?.window === 'day'
      ? ' today'
      : tightest?.window === 'week'
        ? ' this week'
        : tightest?.window === 'month'
          ? ' this month'
          : '';
  return { text: `${remaining} ${remaining === 1 ? 'proposal' : 'proposals'} left${period}`, blocked: false };
}
